import React from 'react';
import PropTypes from 'prop-types';
import { FieldConnect } from 'react-components-form';

export const SubmitField = ({
    wrapperClassName = '',
    className = '',
    submit,
    value = 'Submit',
    fieldAttributes = {},
}) => (
    <div className={wrapperClassName}>
        <button
            onClick={submit}
            className={className}
            {...fieldAttributes}
        >
            {value}
        </button>
    </div>
);

SubmitField.propTypes = {
    wrapperClassName: PropTypes.string,
    className: PropTypes.string,
    submit: PropTypes.func.isRequired,
    value: PropTypes.node,
    fieldAttributes: PropTypes.shape({}),
};

export default FieldConnect(SubmitField);
